import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param Object object
 * @param organisationId String
 * @param blockUI boolean
 * @return {Promise<any>|Promise}
 */
export default (function (object, organisationKey, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var url = applyPathVariables(EndPoints.DEVICE_DETACH, {
        organisationId: organisationKey
    });
    var request = new Request({
        method: Methods.POST,
        url: url,
        data: object,
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
